import { useMemo } from "react";
import { MediaAsset } from "pages/media/types";
import { useConfigurationValue } from "@/hooks/useSystemConfiguration";
import { Configurations } from "@/constants";
import { useLoadAllAssets } from "./useLoadAllAssets";

export const usePublicMediaAssets = () => {
  const PUBLIC_LIBRARY_ID = useConfigurationValue<string>(
    Configurations.PUBLIC_LIBRARY_FONT
  );
  const defaultPublicFontId = useConfigurationValue<string>(
    Configurations.DEFAULT_PUBLIC_FONT_ID
  );

  const {
    fonts: publicFonts,
    isLoading,
    isFetching,
  } = useLoadAllAssets({
    currentAssetLibraryId: PUBLIC_LIBRARY_ID ?? "",
    staleTime: 60 * 60 * 1000, // 1 hour
  });

  const getPublicFontById = (id?: string | null) => {
    if (!id) return undefined;
    return publicFonts?.find((font) => font.id === id);
  };

  const defaultPublicFont = useMemo(() => {
    return publicFonts?.find((font) => font.id === defaultPublicFontId);
  }, [defaultPublicFontId, publicFonts]);

  const fontIsArabic = (font: MediaAsset) => {
    return font.tags?.some((tag) => tag.toLowerCase() === "arabic");
  };

  const defaultArabicFont = useMemo(() => {
    return publicFonts.find(
      (font) => fontIsArabic(font) && font.tags?.includes("Default")
    );
  }, [publicFonts]);

  return {
    publicFonts,
    defaultPublicFontId,
    defaultPublicFont,
    getPublicFontById,
    defaultArabicFont,
    isLoading,
    isFetching,
  };
};
